import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';

export const DATA_ENVIRONMENTS = ['dev', 'stage', 'alpha1', 'alpha2', 'alpha3', 'beta1'] as const;

export type DataEnvironment = (typeof DATA_ENVIRONMENTS)[number];
const PROJECT_ID_MAP: Record<DataEnvironment, GcpProjectId> = {
    dev: 'am-lastarchon-dev',
    stage: 'am-lastarchon-stage',
    alpha1: 'am-lastarchon-alpha1',
    alpha2: 'am-lastarchon-alpha2',
    alpha3: 'am-lastarchon-alpha3',
    beta1: 'am-lastarchon-beta1',
};

// current production environment
export const DEFAULT_ENV: DataEnvironment = 'alpha3';

/**
 * Checks if the provided env is a valid DataEnvironment.
 * @param env
 * @returns True if env is a valid DataEnvironment, false otherwise.
 */
export function isValidEnv(env: string | null): env is DataEnvironment {
    return DATA_ENVIRONMENTS.includes(env as DataEnvironment);
}

/**
 * Normalizes the data environment value.
 * If the provided env is not recognized, it returns the default environment.
 * @param env
 * @returns Normalized DataEnvironment value
 */
export function normalizeEnv(env: string | null): DataEnvironment {
    return isValidEnv(env) ? env : DEFAULT_ENV;
}

/**
 * Gets GcpProjectId based on the provided DataEnvironment.
 * @param env DataEnvironment
 * @returns Corresponding GcpProjectId
 */
export function getGcpProjectIdForEnv(env: DataEnvironment): GcpProjectId {
    return PROJECT_ID_MAP[env];
}
